import {
  Pagination,
  PaginationContainer,
  PaginationSeparator,
  PaginationPrevious,
  PaginationPage,
  usePagination,
  PaginationNext,
  PaginationPageGroup,
} from "@ajna/pagination";
import { useLanguage } from "contexts/LocalizationContext";
import { useRouter } from "next/router";
import { ArrowRightIcon } from "styles/icons";
import PropTypes from "prop-types";
import { ChakraProvider } from "@chakra-ui/react";
import { ChakraTheme, Chakra } from "@airhelp/react-ui-components";
import {
  BLOG_ITEMS_PER_PAGE,
  PAGINATION_INNER_LIMIT,
  PAGINATION_INNER_LIMIT_MOBILE,
  PAGINATION_OUTER_LIMIT,
  PAGINATION_OUTER_LIMIT_MOBILE,
} from "../const";

const { useBreakpointValue } = Chakra;

const PaginationComponent = ({ page, total }) => {
  const router = useRouter();
  const language = useLanguage();
  const { pages, currentPage, setCurrentPage, pagesCount, isDisabled } = usePagination({
    total,
    initialState: {
      pageSize: BLOG_ITEMS_PER_PAGE,
      currentPage: parseInt(page, 10),
      isDisabled: false,
    },
    limits: {
      outer: useBreakpointValue({ base: PAGINATION_OUTER_LIMIT_MOBILE, md: PAGINATION_OUTER_LIMIT }),
      inner: useBreakpointValue({ base: PAGINATION_INNER_LIMIT_MOBILE, md: PAGINATION_INNER_LIMIT }),
    },
  });

  const handlePageChange = (nextPage) => {
    const nextPageUrl = nextPage === 1 ? `/${language}/blog/` : `/${language}/blog/?page=${nextPage}`;
    setCurrentPage(nextPage);
    router.push(nextPageUrl);
    window.scrollTo(0, 0);
  };

  const paginationContainerStyles = {
    ".call-to-action": {
      display: "none!important",
    },
    svg: { boxSize: 4 },
  };

  return (
    <ChakraProvider theme={ChakraTheme}>
      <Pagination
        pagesCount={pagesCount}
        currentPage={currentPage}
        isDisabled={isDisabled}
        onPageChange={handlePageChange}
      >
        <PaginationContainer justifyContent="center" w="full" sx={paginationContainerStyles}>
          <PaginationPrevious boxSize={10} variant="subtleBlue">
            <ArrowRightIcon color="greyscale.500" transform="rotate(180deg)" />
          </PaginationPrevious>
          <PaginationPageGroup
            separator={
              <PaginationSeparator
                cursor="auto"
                color="primary.500"
                _hover={{
                  background: "white",
                }}
              />
            }
          >
            {pages.map((p) => (
              <PaginationPage
                key={`pagination_page_${p}`}
                page={p}
                w={8}
                h={10}
                fontSize="sm"
                color="primary.500"
                background="white"
                _hover={{
                  color: "primary.700",
                  background: "primary.200",
                }}
                _current={{
                  color: "primary.800",
                  background: "primary.200",
                }}
                _active={{
                  color: "primary.800",
                  background: "primary.200",
                }}
              />
            ))}
          </PaginationPageGroup>
          <PaginationNext boxSize={10} variant="subtleBlue" color="red">
            <ArrowRightIcon color="greyscale.500" />
          </PaginationNext>
        </PaginationContainer>
      </Pagination>
    </ChakraProvider>
  );
};

export default PaginationComponent;

PaginationComponent.propTypes = {
  page: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
};
